import { ForFilmmakersSections } from '../components/for-filmmakers/ForFilmmakersSections';
import { MarketingLandingShell } from '../components/marketing/MarketingLandingShell';
import { JsonLd } from '../components/seo/JsonLd';
import { PageSeo } from '../components/seo/PageSeo';
import { buildForFilmmakersPageSchema } from '../lib/schema';
import { FOR_FILMMAKERS_META } from '../lib/seo';
import '../styles/solutions-landing.css';
import '../styles/for-filmmakers.css';

export function ForFilmmakersPage() {
  return (
    <>
      <PageSeo meta={FOR_FILMMAKERS_META} />
      <JsonLd data={buildForFilmmakersPageSchema()} />
      <MarketingLandingShell>
        <ForFilmmakersSections />
      </MarketingLandingShell>
    </>
  );
}
